import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const MembershipCancelView = angular
  .module('acme.view.application.membership.cancel', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.detailList',
    'acme.view.application.membership.cancel.controllers',
  ])
  .config(function config($stateProvider) {
    const membershipCancel = {
      name: 'application.membership.cancel',
      url: '/cancel?membershipId',
      views: {
        'subview-main': {
          controller: 'MembershipCancelController',
          controllerAs: '$ctrl',
          templateUrl: 'views/application/views/membership/cancel/cancel.tpl.html',
        },
      },
      data: {
        pageTitle: 'Cancel Membership and Refund',
        permissions: ['MEMBERSHIP_SALES'],
      },
      resolve: {
        MembershipData: [
          '$stateParams',
          'ApiService',
          function ($stateParams, ApiService) {
            return ApiService.membership.detail($stateParams.membershipId);
          },
        ],
      },
    };

    $stateProvider.state(membershipCancel);
  }).name;
